import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { FunctionalityFormData } from '../../types/functionalityTypings';
import { functionalityPayloadFactory } from '../../utils/functionalityFunnelsPageFactory';

export function useTryToRequestCreatingFunctionalityFunnelPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: async (payload: FunctionalityFormData) => {
      const factory = await functionalityPayloadFactory(payload);

      const response =
        await apiCancellationFunnels.tryToRequestCreatingFunctionality(factory);

      return response;
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao criar o funil de Funcionalidade',
        'Ocorreu um erro ao criar o funil de Funcionalidade, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestCreatingFunctionalityFunnelPage: mutateAsync,
    isLoadingCreatingFunctionality: isLoading,
  };
}
